import { findNodeById } from '__mocks__/helpers/find'
import promotions from '../fixtures/promotions.json'
import paginate from '../helpers/paginate'
import { TResponseResolver } from '../types'

const delay = 800

export const mockPromotions: TResponseResolver = async (req, res, ctx) => {
  return res(ctx.delay(delay), ctx.status(200), ctx.json(promotions))
}
